import type { PropsWithChildren } from 'react';

import { Container } from './styles';

interface AnimationWrapperProps
  extends PropsWithChildren<{
    isCollapsed?: boolean;
    isExpanded?: boolean;
  }> {}

export const AnimationWrapper = ({ children, isCollapsed, isExpanded }: AnimationWrapperProps) => {
  return (
    <Container isExpanded={isExpanded} isCollapsed={isCollapsed} data-testid="container">
      {children}
    </Container>
  );
};
